import { render } from "./Antrag.vue?vue&type=template&id=609dca2f&scoped=true"
import script from "./Antrag.vue?vue&type=script&lang=js"
export * from "./Antrag.vue?vue&type=script&lang=js"

import "./Antrag.vue?vue&type=style&index=0&id=609dca2f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-609dca2f"]])

export default __exports__